<template>
  <v-row justify="center">
    <v-dialog
      v-model="open"
      width="750px"
      scrollable
      :fullscreen="isMobileBreakpoint"
    >
      <v-card flat>
        <v-toolbar class="drm-toolbar" elevation="0">
          <v-toolbar-title class="pl-3 text--subtitle">
            <div class="d-flex flex-column mt-2">
              <span
                >{{ edit ? $t('message.edit') : $t('message.create') }}
                {{ $t('message.pages.drm.modalListKey.title') }}
              </span>
              <span class="body-regular-smaller">
                {{ $t('message.pages.drm.modalListKey.description') }}
                <a
                  target="_blank"
                  type="secondary"
                  :href="$t('message.pages.drm.drmWatermark.howToUseHref')"
                >
                  <span class="body-bold-smaller">
                    {{ $t('message.playerPage.playerTabs.learnMore') }}
                  </span>
                  <v-icon class="body-bold-smaller" size="12"
                    >mdi-open-in-new</v-icon
                  >
                </a>
              </span>
            </div>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-tabs
          v-if="edit"
          class="playr-tabs pl-6"
          align-tabs="start"
          fixed-tabs
          v-model="keyTab"
        >
          <v-tab v-for="item in keyTabOptions" :key="item.tab">
            {{ item.tab }}
          </v-tab>
        </v-tabs>
        <v-card-text
          class="pl-7 pr-5 py-0 border-top"
          :style="edit ? 'height: 380px' : 'height: 280px'"
        >
          <div v-if="keyTab === 0" no-gutters class="pt-4">
            <v-row :class="{ 'flex-column': isMobileBreakpoint }">
              <v-col
                style="
                  display: flex;
                  align-items: start;
                  justify-content: center;
                  flex-direction: column;
                "
                ><span class="body-regular-small neutral-20-dark--text">{{
                  $t(
                    'message.pages.drm.hotmartIntegration.panel15.success.privateKey'
                  )
                }}</span>
                <span
                  v-if="!edit"
                  class="body-regular-smaller neutral-40-dark--text"
                  >{{
                    $t('message.pages.drm.modalListKey.specAccessDrm')
                  }}</span
                >
              </v-col>
              <v-col :cols="isMobileBreakpoint ? '12' : '6'">
                <v-input
                  hide-details
                  v-model="privateTokenObject.key"
                  :placeholder="
                    $t('message.pages.drm.drmListKeys.typePrivateKey')
                  "
                  :disabled="edit"
                ></v-input>
              </v-col>
            </v-row>
            <v-row :class="{ 'flex-column': isMobileBreakpoint }">
              <v-col style="display: flex; align-items: center"
                ><span class="body-regular-small neutral-20-dark--text"
                  >{{ this.$t('message.pages.drm.field') }} 1</span
                ></v-col
              >
              <v-col :cols="isMobileBreakpoint ? '12' : '6'">
                <v-input
                  hide-details
                  v-model="privateTokenObject.string1"
                  @input="hasChanges = true"
                  :placeholder="
                    $i18next.t(
                      'message.pages.welcomePanda.actions.insertHere'
                    ) + '...'
                  "
                ></v-input>
              </v-col>
            </v-row>
            <v-row :class="{ 'flex-column': isMobileBreakpoint }">
              <v-col style="display: flex; align-items: center"
                ><span class="body-regular-small neutral-20-dark--text"
                  >{{ this.$t('message.pages.drm.field') }} 2</span
                ></v-col
              >
              <v-col :cols="isMobileBreakpoint ? '12' : '6'">
                <v-input
                  hide-details
                  v-model="privateTokenObject.string2"
                  @input="hasChanges = true"
                  :placeholder="
                    $i18next.t(
                      'message.pages.welcomePanda.actions.insertHere'
                    ) + '...'
                  "
                ></v-input>
              </v-col>
            </v-row>
            <v-row :class="{ 'flex-column': isMobileBreakpoint }">
              <v-col style="display: flex; align-items: center"
                ><span class="body-regular-small neutral-20-dark--text"
                  >{{ this.$t('message.pages.drm.field') }} 3</span
                ></v-col
              >
              <v-col :cols="isMobileBreakpoint ? '12' : '6'">
                <v-input
                  hide-details
                  v-model="privateTokenObject.string3"
                  @input="hasChanges = true"
                  :placeholder="
                    $i18next.t(
                      'message.pages.welcomePanda.actions.insertHere'
                    ) + '...'
                  "
                ></v-input>
              </v-col>
            </v-row>
            <v-row class="justify-space-between" v-if="edit">
              <v-col style="display: flex; flex-direction: column"
                ><span class="body-bold-base neutral-20-dark--text">{{
                  $t('message.pages.drm.modalListKey.enabledVisualization')
                }}</span
                ><span class="body-regular-smaller neutral-20-dark--text">{{
                  $t(
                    'message.pages.drm.modalListKey.enabledVisualizationDescription'
                  )
                }}</span></v-col
              >
              <v-col cols="6" style="display: flex; justify-content: end">
                <v-switch
                  v-model="privateTokenObject.status_key"
                  @change="hasChanges = true"
                  class="mt-0 pt-0"
                  dense
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>
            <v-col cols="12" class="mt-4" v-if="updateError">
              <v-alert dense outlined type="error" width="100%">
                <span>
                  {{
                    errMsg
                      ? errMsg
                      : $t('message.pages.qualitySettings.errors.defaultError')
                  }}.
                  {{ `${$t('message.commom.code')}: ${errCode}` }}
                </span>
              </v-alert>
            </v-col>
          </div>
          <v-row v-if="keyTab === 1" no-gutters>
            <v-row no-gutters v-if="metadataLoading">
              <v-col cols="12">
                <loading-logo :value="200" />
              </v-col>
            </v-row>
            <v-col
              cols="12"
              class="mt-5"
              v-else-if="
                privateTokenObject.logs && privateTokenObject.logs.length
              "
            >
              <v-row no-gutters class="pr-0 py-0">
                <v-col cols="2">
                  <span class="body-label-xs neutral-40-light--text">{{
                    $t('message.pages.historyModal.column1')
                  }}</span>
                </v-col>
                <v-col cols="4">
                  <span class="body-label-xs neutral-40-light--text">{{
                    $t('message.pages.historyModal.column2')
                  }}</span>
                </v-col>
                <v-col cols="6">
                  <span class="body-label-xs neutral-40-light--text">{{
                    $t('message.pages.drm.createKey.relevantInfo')
                  }}</span>
                </v-col>
              </v-row>
              <v-col cols="12" class="mx-0 px-0 mb-2">
                <v-divider />
              </v-col>
              <v-card-text class="pa-0" style="height: 200px">
                <template>
                  <v-row
                    v-if="!privateTokenObject.logs.length"
                    class="d-flex flex-column mt-4"
                    no-gutters
                    justify="center"
                    align="center"
                  >
                    <span class="body-regular-smaller neutral-40-light--text">
                      {{ $t('message.pages.drm.keyModal.noRelevantInfo') }}
                    </span>
                  </v-row>
                  <v-row
                    v-else
                    no-gutters
                    v-for="(log, i) in privateTokenObject.logs"
                    :key="i"
                  >
                    <v-col cols="2">
                      <span
                        class="body-regular-smaller neutral-40-light--text"
                        >{{
                          $t(
                            `message.pages.drm.logs.${log.json.type.toUpperCase()}`
                          )
                        }}</span
                      >
                    </v-col>
                    <v-col cols="4">
                      <span class="body-regular-smaller neutral-40-light--text">
                        {{ parseDate(log.date) }}
                        {{ $t('message.pages.drm.createKey.at') }}
                        {{ parseHours(log.date) }}</span
                      >
                    </v-col>
                    <v-col
                      cols="6"
                      v-if="log.json.webhook && log.json.webhook.customer"
                    >
                      <v-row no-gutters>
                        <v-col
                          cols="12"
                          v-for="(detail, i) in log.json.webhook.customer"
                          :key="detail"
                        >
                          <v-row no-gutters>
                            <v-col cols="2">
                              {{ capitalizeFirstLetter(i) }}:
                            </v-col>
                            <v-col
                              cols="10"
                              class="body-regular-smaller neutral-40-light--text"
                              >{{ detail }}</v-col
                            >
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="5"
                      v-else
                      class="body-regular-smaller neutral-40-light--text"
                    >
                      {{ $t('message.pages.drm.keyModal.noInfo') }}
                    </v-col>
                    <v-col cols="12" class="pa-0 py-4"> </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-5 py-4 border-top">
          <base-btn
            v-if="edit"
            type="danger"
            class="mr-4 px-4"
            :disabled="isFetching || !hasEditDrmPerm"
            :loading="isFetchingRemove"
            @click="handleDeleteKey"
          >
            {{ $t('message.pages.drm.drmListKeys.removeKey') }}
          </base-btn>
          <v-spacer></v-spacer>
          <base-btn
            v-if="keyTab === 0"
            text
            class="mr-4 px-4"
            type="tertiary"
            :disabled="isFetching || isFetchingRemove"
            @click="handleClose"
          >
            {{ $t('message.cancel') }}
          </base-btn>
          <base-btn
            v-if="keyTab === 0"
            large
            min-width="185px"
            @click="handleConfirm"
            :loading="isFetching"
            :disabled="
              isFetching ||
              isFetchingRemove ||
              !hasMinimumFieldsFilled ||
              !hasEditDrmPerm ||
              !hasChanges
            "
          >
            {{
              edit
                ? $t('message.pages.drm.modalListKey.editKey')
                : $t('message.pages.drm.modalListKey.createKey')
            }}
          </base-btn>
          <base-btn v-else text min-width="185px" large @click="handleClose">
            {{ $t('message.actions.close') }}
          </base-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import drmApi from '@/services/drmApi'
import i18n from '@/translations/lang'
import LoadingLogo from '@/components/LoadingLogo.vue'

export default {
  name: 'DrmCreateSecretKey',
  components: {
    LoadingLogo,
  },
  data: () => ({
    open: false,
    edit: false,
    isFetching: false,
    isFetchingRemove: false,
    hasChanges: false,
    privateTokenObjectStart: {
      drm_group_id: '',
      string1: '',
      string2: '',
      string3: '',
      key: '',
      logs: [],
      status_key: true,
    },
    privateTokenObject: {
      drm_group_id: '',
      string1: '',
      string2: '',
      string3: '',
      key: '',
      logs: [],
      status_key: true,
    },
    tokenId: '',
    drmGroup: {
      id: '',
    },
    metadataLoading: false,
    metadataSearched: false,
    keyTab: 0,
    keyTabOptions: [
      { tab: i18n.t('message.pages.drm.keyModal.tabOption') },
      { tab: 'Logs' },
    ],
    updateError: false,
    errMsg: '',
    errCode: '402',
  }),
  computed: {
    ...mapState({
      profile: (state) => state.video.profile,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
      isTabletBreakpoint: (state) => state.user.isTabletBreakpoint,
    }),
    hasEditDrmPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-watermark') ??
        false
      )
    },
    hasMinimumFieldsFilled() {
      return (
        !!this.privateTokenObject.key &&
        (this.privateTokenObject?.string1?.length > 2 ||
          this.privateTokenObject?.string2?.length > 2 ||
          this.privateTokenObject?.string3?.length > 2)
      )
    },
  },
  watch: {
    open() {
      const refForm = this.$refs.form
      refForm && refForm.resetValidation()
    },
  },
  mounted() {
    this.$root.$on('openDrmSecretKey', (data) => {
      Object.assign(this.$data, this.initialState())
      this.edit = data.edit
      if (data.edit) {
        console.log()
        this.privateTokenObject = data.item
        this.privateTokenObjectStart = data.item
        this.tokenId = data.item.id
      } else {
        this.privateTokenObject.drm_group_id = data.group.id
      }
      this.open = true
      this.drmGroup = data.group
      this.getMetadata()
    })
  },
  beforeDestroy() {
    this.$root.$off('openDrmSecretKey')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('user', ['addUser', 'editUser', 'addFolder', 'editFolder']),
    handleCopyItem(item) {
      navigator.clipboard.writeText(`${JSON.stringify(item)}`)
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: 'Informações adicionais copiadas com sucesso!',
      })
    },
    capitalizeFirstLetter(val) {
      return val.charAt(0).toUpperCase() + val.slice(1)
    },
    async getMetadata() {
      this.metadataLoading = true
      if (!this.tokenId) return
      try {
        let ret = await drmApi.getOneDrmPrivateToken(this.tokenId)
        this.privateTokenObject = ret.data
        this.privateTokenObjectStart = ret.data
        this.metadataSearched = true
      } catch (e) {
        this.metadataLoading = false
        console.log('e', e)
      }
      this.metadataLoading = false
    },
    handleDeleteKey() {
      const selectedKeys = [this.tokenId]
      this.$root.$emit('drmDeleteKey', {
        group: this.selectedDrmGroup,
        keys: selectedKeys,
      })
      this.handleClose()
    },
    handleConfirm() {
      if (this.edit) {
        this.handleEdit()
      } else {
        this.handleCreate()
      }
    },
    async handleCreate() {
      this.isFetching = true
      this.trimFields()
      if (!this.metadataSearched) {
        delete this.privateTokenObject.logs
      }
      try {
        await drmApi.createDrmPrivateToken(this.privateTokenObject)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'success',
          text: this.$t('message.pages.drm.drmListKeys.addKey'),
        })
        this.$root.$emit('reloadTokens')
        this.handleClose()
      } catch (e) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'error',
          text: this.$t('message.pages.warningPaymentIssues.error'),
        })
        console.log('e', e)
      }
      this.isFetching = false
    },
    async handleEdit() {
      this.updateError = false
      this.isFetching = true
      this.trimFields()
      try {
        await drmApi.drmUpdatePrivateToken(this.tokenId, {
          drm_group_id: this.privateTokenObject.drm_group_id,
          string1: this.privateTokenObject.string1,
          string2: this.privateTokenObject.string2,
          string3: this.privateTokenObject.string3,
          status_key: this.privateTokenObject.status_key,
        })
        this.$root.$emit('reloadTokens')
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'success',
          text: this.$t('message.pages.drm.drmApparence.tooltip'),
        })
        this.handleClose()
      } catch (e) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'error',
          text: this.$t('message.pages.warningPaymentIssues.error'),
        })
        this.updateError = true
        if (e.response.status) this.errCode = e.response.status
        if (e.response.data.errMsg) this.errMsg = e.response.data.errMsg
      }
      this.isFetching = false
    },
    async handleRemove() {
      this.isFetchingRemove = true
      let arr = []
      arr.push({ id: this.privateTokenObject.id })
      try {
        await drmApi.deleteMultipleDrmPrivateToken(arr)
        this.$root.$emit('removePrivateTokens', arr)
        this.handleClose()
      } catch (e) {
        console.log('e', e)
      }
      this.isFetchingRemove = false
    },
    parseType(type) {
      if (type === 'recover')
        return i18n.t('message.pages.historyModal.recover')
      if (type === 'delete') return i18n.t('message.pages.historyModal.delete')
      return type
    },
    parseDate(timestamp) {
      let date = new Date(timestamp)
      return (
        date.toLocaleString('pt-BR').slice(0, 3) +
        date.toLocaleString('pt-BR', { month: 'long' }).slice(0, 3) +
        '/' +
        date.toLocaleString('pt-BR').slice(6, 10)
      )
    },
    parseHours(timestamp) {
      let date = new Date(timestamp)
      return date.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      })
    },
    handleClose() {
      this.open = false
      this.hasChanges = false
    },
    trimFields() {
      this.privateTokenObject.string1 = this.privateTokenObject.string1.trim()
      this.privateTokenObject.string2 = this.privateTokenObject.string2.trim()
      this.privateTokenObject.string3 = this.privateTokenObject.string3.trim()
      this.privateTokenObject.key = this.privateTokenObject.key.trim()
    },
    initialState() {
      return {
        open: false,
        edit: false,
        isFetching: false,
        isFetchingRemove: false,
        privateTokenObject: {
          drm_group_id: '',
          string1: '',
          string2: '',
          string3: '',
          key: '',
          logs: [],
          status_key: true,
        },
        tokenId: '',
        drmGroup: {
          id: '',
        },
        metadataLoading: false,
        metadataSearched: false,
        keyTab: 0,
        keyTabOptions: [
          { tab: this.$t('message.pages.drm.drmListKeys.infoKey') },
          { tab: this.$t('message.pages.drm.logs.title') },
        ],
      }
    },
  },
}
</script>

<style lang="scss">
.border-top {
  border-top: 1px solid varFigma(neutral-95-lightest);
}

.bgImg {
  background-image: url('../../assets/pandaVideoScreenShot.jpg');
  background-size: contain;
}

.pointer {
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
@import '@/assets/scss/_typography';

.tab-icon {
  background: url('../../assets/playerTabs/moneyBag.png');
  width: 18px;
  height: 24px;
  vertical-align: middle;
  background-size: 14px;
  background-position: right;
  background-repeat: no-repeat;
}

.drm-toolbar {
  flex: inherit;
  max-height: 64px;
  margin-bottom: 16px;
  margin-top: 8px;
}

.playr-tabs {
  &::v-deep {
    .v-slide-group__prev {
      display: none !important;
    }

    .v-slide-group__next {
      display: none !important;
    }

    .v-slide-group__content {
      height: 28px;
      flex: 1 1 auto !important;
    }
  }

  &.v-tabs {
    padding: 0;
    flex: inherit;
    max-height: 28px;

    &::v-deep {
      .v-tabs-bar {
        height: 28px;

        .v-tab {
          font-size: $font-size-small;
          height: 24px;
          text-transform: initial;
          letter-spacing: 0px;
          border-bottom: 2px solid transparent;
          padding: 0;
          min-width: auto;
          margin-right: $spacing-05;
          white-space: nowrap;
          justify-content: flex-start;
          max-width: fit-content;
          margin-left: 0 !important;

          &--active {
            color: varFigma(brand-50);
            border-bottom: 2px solid varFigma(brand-50);

            &:hover {
              color: varFigma(brand-40-dark);
            }
          }

          &:not([class*='active']) {
            color: var(--v-neutral-lighten1);

            &:hover {
              color: varFigma(neutral-30-base);
              border-bottom: 2px solid varFigma(neutral-80-lighter);
            }
          }
        }

        &.v-tabs-bar--is-mobile {
          .v-tab {
            font-size: 12px;
          }
        }
      }

      & .v-tab:hover::before,
      .v-tab::before {
        opacity: 0 !important;
      }

      & .v-tab:focus::before {
        opacity: 0 !important;
      }
    }

    &::v-deep {
      &.theme--dark {
        > .v-tabs-bar {
          .v-tab {
            &--active {
              color: var(--v-brand-lighten1);
            }
          }
        }
      }

      .v-tabs-slider-wrapper {
        display: none !important;
      }
    }
  }
}
</style>
